import { db } from "@/main";
import firebase from "firebase";
import router from "@/router/index.js";

const dbconnection = process.env.VUE_APP_DB_COLLECTION_CLIENTS;

const state = {
  clients: [],
  client: {},
  editMode: false,
  safeClients: [],
  administrators: [],
  companyData: {}
};

const getters = {
  getClients(state) {
    return state.clients;
  },
  getClient(state) {
    return state.client;
  },
  getEditMode(state) {
    return state.editMode;
  },
  getSafeClients(state) {
    return state.safeClients;
  },
  getAdmins(state) {
    return state.administrators;
  },
  getCompanyData(state) {
    return state.companyData;
  }
};

const mutations = {
  setCompanyData(state, payload) {
    state.companyData = payload;
  },
  setClients(state, payload) {
    state.clients = payload;
  },
  addClient(state, payload) {
    state.clients.push(payload);
  },
  setClient(state, payload) {
    state.client = payload;
  },
  setEditMode(state, payload) {
    state.editMode = payload;
  },
  setSafeClients(state, payload) {
    state.safeClients = payload;
  },
  setAdmins(state, payload) {
    state.administrators = payload;
  }
};
/*eslint-disable */
const actions = {
  takeAllClients({ commit }) {
    const arr = [];
    commit("setLoading", true);
    db.collection(dbconnection).onSnapshot(snapshot => {
      snapshot.docs.forEach(doc => {
        arr.push(doc.data());
      });
    });
    commit("setClients", arr);
    commit("setSafeClients", arr);
    commit("setLoading", false);
  },
  createClient({ commit }, payload) {
    commit("setLoading", true);
    delete payload.id;
    db.collection(dbconnection)
      .add(payload)
      .then(docRef => {
        db.collection(dbconnection)
          .doc(docRef.id)
          .update({
            docId: docRef.id
          })
          .finally(() => {
            router.push("/customers");
            commit("setLoading", false);
          });
      });
  },
  editClient({ commit }, payload) {
    commit("setLoading", true);
    db.collection(dbconnection)
      .where("companyRegistrationId", "==", payload.companyRegistrationId)
      .onSnapshot(snapshot => {
        snapshot.docs.forEach(doc => {
          payload.docId = doc.id;
        });
        commit("setClient", payload);
        router.push("/add-customer");
        commit("setLoading", false);
      });
  },
  deleteClient({ commit, dispatch }, payload) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection(dbconnection)
      .doc(payload)
      .delete()
      .then(() => {
        dispatch("takeAllClients");
        commit("setLoading", false);
      })
      .catch(err => err);
  },
  editMode({ commit }, payload) {
    commit("setEditMode", payload);
  },
  commitClientEdit({ commit }, payload) {
    commit("setLoading", true);
    db.collection(dbconnection)
      .doc(payload.docId)
      .update(payload)
      .then(() => {
        commit("setClient", {});
        commit("setLoading", false);
        router.push("/customers");
      });
  },
  addUsersToCustomer({ commit, dispatch }, payload) {
    commit("setLoading", true);
    var firebaseConfig = {
      apiKey: process.env.VUE_APP_API_KEY,
      authDomain: process.env.VUE_APP_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_DATABASE_URL
    };

    var secondaryApp = firebase.initializeApp(firebaseConfig, "Secondary");
    const backUpData = JSON.parse(localStorage.getItem("user"));
    const docId = payload.client.docId;
    const usrArray =
      payload.client.users && payload.client.users.length > 0
        ? payload.client.users
        : [];
    const userIds =
      payload.client.usrIds && payload.client.usrIds.length > 0
        ? payload.client.usrIds
        : [];
    const newUr = {
      name: payload.firstAndLastName,
      phoneNumber: payload.phoneNumber,
      companyId: docId,
      email: payload.email,
      password: payload.password,
      type: "customer",
      companyName: payload.client.companyName
    };
    // usrArray.push(newUr);
    secondaryApp
      .auth()
      .createUserWithEmailAndPassword(newUr.email, newUr.password)
      .then(resp => {
        newUr.id = resp.user.uid;
        delete newUr.password;
        // localStorage.setItem("user", backUpData);
        db.collection("users")
          .add(newUr)
          .then(docRef => {
            userIds.push(docRef.id);
            db.collection(dbconnection)
              .doc(docId)
              .update({
                // users: usrArray,
                usrIds: userIds
              })
              .finally(() => {
                // firebase
                //   .auth()
                //   .signOut()
                //   .then(() => {
                //     localStorage.setItem("user", JSON.stringify(backUpData));
                //     // dispatch("autoSignIn", { uid: backUpData.id });
                //   });
                router.push("/dashboard");
                commit("setLoading", false);
              });
          });
      });
  },
  createAdminAccount({ commit }, payload) {
    commit("setLoading", true);
    firebase
      .auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then(user => {
        payload.id = user.user.uid;
        delete payload.password;
        db.collection("users").add(payload);
      });
    commit("setLoading", false);
  },
  getAllAdminAccounts({ commit }) {
    const arr = [];
    commit("setLoading", true);
    db.collection("users")
      .where("type", "==", "admin")
      .onSnapshot(snapshot => {
        snapshot.docs.forEach(doc => {
          arr.push(doc.data().name);
        });
        commit("setAdmins", arr);
        commit("setLoading", false);
      });
  },
  getClientsCompany({ commit, dispatch }, payload) {
    var query = db.collection(dbconnection);
    if (payload.companyId) {
      query = query.where(
        firebase.firestore.FieldPath.documentId(),
        "==",
        payload.companyId
      );
    }
    if (payload.companyName) {
      query = query.where("companyName", "==", payload.companyName);
    }
    commit("setLoading", true);
    query.get().then(snapshot => {
      commit("setCompanyData", snapshot.docs[0].data());
      dispatch("getAllWorklogs", {
        closedTickets: payload.closedTickets,
        companyName: snapshot.docs[0].data().companyName
      });
      commit("setLoading", false);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
